<template>
  <div class="categories-storechild">
    <v-card class="card-loading" v-if="pageLoading">
      <div class="text-center">
        <looping-rhombuses-spinner
          :animation-duration="2500"
          :rhombus-size="15"
          color="#6200ea"
          class="mx-auto my-10"
        />
      </div>
    </v-card>
    <v-card class="card-page-storechild" v-else>
      <v-col xl="2" lg="2" md="3" sm="3" xs="3" cols="12">
        <div class="bottom-right-image">
          <img src="/reading.png" alt="کتاب باز" />
        </div>
        <div class="top-right-image">
          <img src="/reading2.png" alt="کتاب باز" />
        </div>
      </v-col>
      <v-col xl="8" lg="8" md="12" sm="12" xs="12" cols="12">
        <div v-if="allItems.length > 0" class="d-flex flex-column">
          <div class="card_storechild">
            <v-col
              v-for="(item, index) in allItems"
              :key="index"
              xl="3"
              lg="4"
              md="6"
              sm="6"
              xs="12"
              cols="12"
              align="center"
            >
              <StoreItem :item="item" :cart-id="cartId" />
            </v-col>
          </div>
          <div class="mt-6 d-none d-md-block">
            <v-pagination
              v-model="currentPage"
              :length="totalPages"
              :total-visible="5"
              circle
              color="shopPrimary"
              prev-icon="$ArrowLeft"
              next-icon="$ArrowRight"
              @input="next()"
            ></v-pagination>
          </div>
          <div class="mt-6 d-block d-md-none">
            <v-pagination
              v-model="currentPage"
              :length="totalPages"
              :total-visible="4"
              circle
              color="shopPrimary"
              prev-icon="$ArrowLeft"
              next-icon="$ArrowRight"
              @input="next()"
            ></v-pagination>
          </div>
        </div>

        <!--empty-->
        <div class="empty-text" v-else>
          <div class="img-empty">
            <img src="/Closed Stores-rafiki.svg" alt="کتاب باز" />
          </div>
          <h3>محصولی در این صفحه وجود ندارد</h3>
        </div>
      </v-col>
      <v-col xl="2" lg="2" md="3" sm="3" xs="3" cols="12">
        <div class="bottom-left-image">
          <img src="/learning.png" alt="کتاب باز" />
        </div>
        <div class="top-left-image">
          <img src="/studying.png" alt="کتاب باز" />
        </div>
      </v-col>
    </v-card>
  </div>
</template>
<script>
import Axios from "axios";
import { LoopingRhombusesSpinner } from "epic-spinners";
import { mapState } from "vuex";
import ProductCounter from "../../components/OnlineShop/ProductCounter";
import StoreItem from "@/views/OnlineShop/StoreAll/Components/StoreItem";

export default {
  name: "StoreChild",
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    StoreItem,
    ProductCounter,
    LoopingRhombusesSpinner,
  },
  data() {
    return {
      currentPage: 1,
      pageLoading: true,
      availability: false,
      filters: {},
      allItems: [],
      cartId: "",
      latestQuery: "",
      totalPages: 0,
      filterMenu: [],
      divisionsList: [],
      available: false,
      filtersList: {},
      loading: false,
      selectedQuery: [],
      selectedFilter: [],
      selectedQueryPage: "",
      previousQuery: "",
      updateCounter: 0,
    };
  },
  created() {
    const grade = this.query.grade;
    if (grade) {
      this.getFilterProduct([{ key: "grade", selectedFilter: grade }], 1);
    } else {
      console.error("Grade is undefined");
    }
  },
  methods: {
    next() {
      let query = this.selectedQuery;

      this.getFilterProduct(this.selectedQuery, this.currentPage);
    },
    getAll(selectedPage) {
      this.pageLoading = true;
      Axios.get(this.baseUrl + `/onlineShop/items/list?page=${selectedPage}`, {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
      })
        .then((res) => {
          this.allItems = res.data.items;
          this.totalPages = res.data.totalPages;
          this.analyzeFilters(res.data.filters);
          let container = document.getElementsByTagName("html")[0];
          container.scrollIntoView({ block: "start", behavior: "smooth" });
          this.pageLoading = false;
        })
        .catch((err) => {
          this.toast.error("خطا: " + err.response.data);
          this.pageLoading = false;
        });
    },

    getFilterProduct(query, selectedPage) {
      let latestQuery = query;
      let q = "";

      latestQuery.forEach((filter, index) => {
        if (filter.key != "all" && filter.selectedFilter != "") {
          q += filter.key + "=" + filter.selectedFilter;
          if (index < latestQuery.length - 1) q += "&";
        }
      });
      if (q) {
        this.$router.push("/storeChild?" + q);
        this.pageLoading = true;
        Axios.get(
          this.baseUrl + `/onlineShop/items/search?${q}&page=${selectedPage}`,
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            this.allItems = res.data.items;
            this.totalPages = res.data.totalPages;
            this.analyzeFilters(res.data.filters);
            let container = document.getElementsByTagName("html")[0];
            container.scrollIntoView({ block: "start", behavior: "smooth" });
            this.pageLoading = false;
          })
          .catch((err) => {
            this.toast.error("خطا: " + err.response.data);
          });
      }
    },

    addToCart(item) {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/onlineShop/cart/addItem/" + this.cartId,
        {
          amount: 1,
          warehouseItemId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data.message, "success");
            item.amountInCart++;
            this.loading = false;
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast.error(err.response.data);
          this.pageLoading = false;
        });
    },

    removeItem(item) {
      this.pageLoading = true;

      Axios.post(
        this.baseUrl + "/onlineShop/cart/removeItem/" + this.cartId,
        {
          amount: 1,
          warehouseItemId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast.success(res.data.message);
            item.amountInCart--;

            this.pageLoading = false;
          } else {
            this.toast.error("خطایی رخ داده است. مجددا امتحان کنید.");
            this.pageLoading = false;
          }
        })
        .catch((err) => {
          this.toast.error(err.response.data);
          this.pageLoading = false;
        });
    },
    removeFilter(index) {
      if (this.selectedQuery[index].key === "publisher") {
        this.divisionsList = [];
      }
      this.filterMenu.filter(
        (x) => x.key === this.selectedQuery[index].key
      )[0].selectedFilter = undefined;
      this.selectedQuery.splice(index, 1);
      this.currentPage = 1;
      if (this.selectedQuery && this.selectedQuery.length > 0) {
        this.getFilterProduct(this.selectedQuery, this.currentPage);
      } else {
        this.getAll(this.currentPage);
      }
    },
    removeAllFilter() {
      this.selectedQuery = [];
      this.divisionsList = [];
      this.currentPage = 1;
      for (let i = 0; i < this.filterMenu.length; i++) {
        this.filterMenu[i].selectedFilter = undefined;
      }
      this.getAll(this.currentPage);
    },

    setAvailableProducts() {
      this.pageLoading = true;
      if (this.available) {
        this.allItems = this.allItems.filter((x) => x.sum > 0);
      } else {
        this.getFilterProduct(this.selectedQuery, 1);
      }
      this.pageLoading = false;
    },
    updateFilters(item) {
      let filtered;
      filtered = this.filterMenu.filter((f) => {
        if (f.selectedFilter != null) {
          return {
            selectedFilter: f.selectedFilter,
            selectedQuery: f.key,
          };
        }
      });
      this.selectedQuery = filtered;
      if (
        this.selectedQuery.filter((x) => x.key === "publisher").length > 0 &&
        this.filterMenu &&
        this.filterMenu.length > 0
      ) {
        let filtering = this.filterMenu.filter((x) => x.key === "division")[0];
        if (filtering) {
          this.divisionsList = filtering.filter(
            (x) =>
              x.publisherId ===
              this.selectedQuery.filter((x) => x.key === "publisher")[0]
                .selectedFilter
          );
        }
      }
      this.currentPage = 1;
      this.getFilterProduct(this.selectedQuery, this.currentPage);
    },

    analyzeFilters(filters) {
      let filterData = [];
      for (const [key, value] of Object.entries(filters)) {
        let myFilters = [];
        let mySelectedFilters = [];
        try {
          myFilters = this.setCheckedValue(key, value);
          mySelectedFilters = myFilters
            .filter((x) => x.checked)
            .map((x) => x.id);
          if (mySelectedFilters.length)
            mySelectedFilters = mySelectedFilters[0];
          else mySelectedFilters = null;
        } catch (error) {
          mySelectedFilters = null;
        }
        filterData.push({
          title: this.translateFilterMenu(key),
          key,
          filter: myFilters,
          selectedFilter: mySelectedFilters,
        });
      }
      this.filterMenu = filterData;
    },

    translateFilterMenu(key) {
      switch (key) {
        case "grade":
          return "مقطع";
        case "major":
          return "رشته";
        case "entranceExamMajor":
          return "رشته کنکور";
        case "stage":
          return "پایه";
        case "subject":
          return "موضوع";
        case "publisher":
          return "ناشر";
        default:
          return "سری";
      }
    },

    setCheckedValue(key, value) {
      const query = this.$route.params.query;
      const getKey = this.queryStringToObject(query);
      let filter = [];
      for (const iterator of value) {
        filter.push({
          ...iterator,
          checked: iterator.id === getKey[key] ? true : false,
        });
      }
      return filter;
    },

    queryStringToObject(queryString) {
      let obj = {};
      if (queryString) {
        queryString.split("&").map((item) => {
          const [k, v] = item.split("=");
          v ? (obj[k] = v) : null;
        });
      }
      return obj;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.cartId = localStorage.getItem("cartId");
    this.$store.dispatch("getCartData", {
      cartId: this.cartId,
    });

    this.selectedQuery.push({
      selectedFilter: "",
      key: this.$route.params.query,
    });
    this.getFilterProduct(this.selectedQuery, 1);
  },
  computed: {
    ...mapState({
      cart: (state) => state.onlineShop.cart,
      isLoading: (state) => state.onlineShop.isLoading,
      productIndexInCart: (state) => state.onlineShop.productIndexInCart,
    }),
    computedItemsCount() {
      if (this.availability) {
        return this.allItems.filter((x) => x.sum != 0).length;
      } else {
        return this.allItems.length;
      }
    },
    computedItems() {
      let myItems = this.allItems;
      if (this.availability) {
        myItems = myItems.filter((x) => x.sum != 0);
      }
      return myItems;
    },
  },
  watch: {
    $route(to, from) {
      this.selectedQuery = [];

      this.selectedQuery.push({
        selectedFilter: "",
        key: this.$route.params.query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.categories-storechild {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  .top-left-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 180px;
    height: auto;
    display: none;
    @media only screen and (min-width: 1350px) {
      width: 200px;
    }
    @media only screen and (min-width: 1264px) {
      display: flex;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .top-right-image {
    position: absolute;
    top: 0;
    right: 0;
    width: 180px;
    height: auto;
    display: none;
    @media only screen and (min-width: 1350px) {
      width: 200px;
    }
    @media only screen and (min-width: 1264px) {
      display: flex;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }

  .bottom-right-image {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 180px;
    height: auto;
    display: none;
    @media only screen and (min-width: 1350px) {
      width: 200px;
    }
    @media only screen and (min-width: 1264px) {
      display: flex;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .bottom-left-image {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 180px;
    height: auto;
    display: none;
    @media only screen and (min-width: 1350px) {
      width: 200px;
    }
    @media only screen and (min-width: 1264px) {
      display: flex;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .empty-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 400px;

    h3 {
      font-size: 16px;
      color: #4a5f73;
    }
    .img-empty {
      width: 200px;
      height: auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .card-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  .card-page-storechild {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    border-radius: 16px !important;
    box-shadow: none !important;
  }
  .card_storechild {
    display: flex;
    flex-wrap: wrap;
    margin: 0 !important;
    padding: 0 !important;
  }
  .input_radio_select_items {
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-bottom: 0 !important;
    label {
      margin-bottom: 0 !important;
    }
  }
  .box_filter_product {
    .v-expansion-panel {
      background: #fff !important;
    }

    .v-expansion-panel-header {
      background-color: #ffffff;
      counter-reset: white !important;
      &::before {
        background: #fff !important;
      }
    }

    .v-expansion-panel--active > .v-expansion-panel-header {
      min-height: 50px;
      border-bottom: 1px solid #a076f9;
      border-top: 1px solid #a076f9;
      border-radius: 0 !important;
    }
  }

  .details_filter {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    margin-bottom: 5px;

    &::before {
      box-shadow: none !important;
    }

    .v-expansion-panel-title {
      background: transparent !important;
      overflow: hidden !important;
      // border-radius: 8px !important;
      // border-bottom-left-radius: 8px !important;
      // border-bottom-right-radius: 8px !important;

      .v-expansion-panel-title--active {
        background: transparent !important;
      }

      .v-expansion-panel-title__overlay {
        background: transparent !important;
        border: none !important;
      }
    }

    .details_filter_title {
      display: flex;
      align-items: center;

      h6,
      h5 {
        font-size: 16px;
        font-weight: bolder;
        margin: 0 !important;
      }
    }

    .details_filter_contetn {
      background: transparent !important;
      border: none !important;
      margin-top: 5px;
      z-index: 1;

      .v-radio {
        z-index: 100;
        display: flex;
        align-items: center;

        label {
          font-size: 18px;
          color: #4a5f73;

          opacity: 1;
          margin-bottom: 0 !important;
        }
      }
    }

    .v-expansion-panel__shadow {
      box-shadow: none !important;
      border: none !important;
    }
  }

  .switch_input_category {
    .v-label {
      font-size: 16px;
      font-weight: 600;
      color: var(--mainFont);
      opacity: 1;
    }
  }

  .filter-item {
    padding: 0 8px;
  }
}
</style>
